export const MediaType = {
  LIST: "image",
  LOGO: "logo",
  DETAIL: "detail",
};
